import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import { FormattedMessage } from 'react-intl';
import CalendarControl from '../../../components/PageLayout/CalendarControl';
export default function () {
    function onClick1(intl, momentLocale) {
        this.props.selectYear(-1);
    }
    function onClick2(intl, momentLocale) {
        this.props.selectYear(+1);
    }
    function repeatMonth3(intl, momentLocale, month, monthIndex) {
        return React.createElement(CalendarControl, {
            'key': month,
            'year': this.props.visibleYear.year(),
            'month': month,
            'selectedDate': this.props.selectedDate,
            'click': this.props.selectDay
        });
    }
    function onClick4(intl, momentLocale, dayEntry, dayEntryIndex, entry, entryIndex) {
        this.props.editScheduleEntry(entry);
    }
    function repeatEntry5(intl, momentLocale, dayEntry, dayEntryIndex, entry, entryIndex) {
        return React.createElement('div', {
            'className': 'schedule-appointments-dot',
            'style': { backgroundColor: entry.color },
            'key': entry.id,
            'onClick': onClick4.bind(this, intl, momentLocale, dayEntry, dayEntryIndex, entry, entryIndex)
        }, entry.isSelected ? React.createElement('div', {
            'className': 'schedule-appointments-dot-large',
            'style': { backgroundColor: entry.color },
            'key': '3020'
        }) : null);
    }
    function repeatDayEntry6(intl, momentLocale, dayEntry, dayEntryIndex) {
        return React.createElement.apply(this, [
            'div',
            {
                'className': 'schedule-appointments-lir',
                'key': dayEntry.hour
            },
            React.createElement('h1', {}, dayEntry.stringHour),
            _.map(dayEntry.entries, repeatEntry5.bind(this, intl, momentLocale, dayEntry, dayEntryIndex))
        ]);
    }
    function scopeIntlMomentLocale7() {
        var intl = this.props.intl;
        var momentLocale = this.props.intl.locale.split('-')[0];
        return React.createElement('div', { 'className': 'schedule-main-window' }, React.createElement('div', { 'className': 'schedule-top-nav' }, React.createElement('div', {
            'className': 'lightbox-save-button',
            'onClick': this.props.close
        }, React.createElement(FormattedMessage, { 'id': 'messageBox.buttons.close' }))), React.createElement('div', { 'className': 'schedule-scrolling-window' }, React.createElement('div', { 'className': 'schedule-main-wrapper' }, React.createElement('div', { 'className': 'schedule-overview-container' }, React.createElement('div', { 'className': 'schedule-overview-left-panel' }, React.createElement('div', { 'className': 'schedule-appointments-dotted-divider' }), React.createElement('div', { 'className': 'schedule-overview-year-component' }, React.createElement('h1', {}, this.props.visibleYear.format('YYYY')), React.createElement('div', {
            'className': 'schedule-overview-arrow schedule-overview-arrow-left',
            'onClick': onClick1.bind(this, intl, momentLocale)
        }), React.createElement('div', {
            'className': 'schedule-overview-arrow schedule-overview-arrow-right',
            'onClick': onClick2.bind(this, intl, momentLocale)
        })), React.createElement.apply(this, [
            'div',
            { 'className': 'schedule-overview-scroller' },
            _.map([
                0,
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ], repeatMonth3.bind(this, intl, momentLocale))
        ])), React.createElement('div', { 'className': 'schedule-overview-right-panel' }, React.createElement('h2', {}, this.props.selectedDate.locale(momentLocale).format('dddd MMM Do')), React.createElement('div', { 'className': 'schedule-buttons' }, React.createElement('div', {
            'className': 'schedule-new-entry-button-wrapper',
            'onClick': this.props.addScheduleEntry
        }, React.createElement('div', { 'className': 'schedule-new-entry-button' }, React.createElement('div', { 'className': 'schedule-new-entry-button-icon' }), React.createElement(FormattedMessage, { 'id': 'appointmentPopup.addAppointmentButton' }), React.createElement('div', { 'className': 'schedule-new-entry-button-outline' })))), React.createElement('div', { 'className': 'schedule-appointments-borderbox' }, React.createElement.apply(this, [
            'div',
            { 'className': 'schedule-appointments-container' },
            _.map(this.props.dayEntries, repeatDayEntry6.bind(this, intl, momentLocale))
        ])))))));
    }
    return scopeIntlMomentLocale7.apply(this, []);
}